import { MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';
import Autocomplete from 'domains/core/components/Autocomplete';
import CreateNewDropDownItem from 'domains/core/components/CreateNewDropDownItem';
import ButtonVoicePreview from './ButtonVoicePreview';
import useVoiceTemplateList from 'hooks/queries/useVoiceTemplateList';
import { AutocompleteOption } from '../Autocomplete/Autocomplete';
import { URLPaths } from 'models/enums';
import { useHistory } from 'react-router';

const createNewOption = { index: 0, value: undefined as any, label: 'Create New' };
type PropsType = {
    onContentChange: (content: { contentId: number; contentName: string }) => void;
};
const AutocompleteVoiceCallContent = (props: PropsType) => {
    const history = useHistory();

    const [contentInputValue, setContentInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    const [options, setOptions] = useState<AutocompleteOption<number>[]>([createNewOption]);

    const { data: contentOptionList, isLoading } = useVoiceTemplateList();

    useEffect(() => {
        if (!isLoading) {
            let res = contentOptionList?.map((curr, index) => {
                let obj = {
                    index: index + 1,
                    value: curr.id,
                    label: curr.name,
                };
                return obj;
            });
            if (res) setOptions([createNewOption, ...res]);
        }
    }, [isLoading, contentOptionList]);

    const onVoicePreviewClick = () => {};
    const isPreviewVisible = false;

    return (
        <Autocomplete
            freeSolo={false}
            loading={isLoading}
            fullWidth
            getOptionLabel={(option) => option.label ?? ''}
            inputValue={contentInputValue ?? ''}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            label="Content"
            value={selectedValue ?? null}
            leadingIcon={
                contentInputValue ? (
                    <ButtonVoicePreview onClick={onVoicePreviewClick} isActive={isPreviewVisible} />
                ) : null
            }
            onChange={(event, newValue) => {
                if (!newValue) {
                    props.onContentChange({ contentId: null, contentName: '' });
                    setContentInputValue(null);
                }
                let contentObj = {
                    contentId: newValue?.value,
                    contentName: newValue?.label,
                };
                props.onContentChange(contentObj);
                setSelectedValue(newValue);
                setContentInputValue(newValue?.label ?? '');
            }}
            onInputChange={(_e, inputValue) => {
                setContentInputValue(inputValue);
            }}
            options={options ?? []}
            placeholder="Select or create content"
            renderOption={({ className, ...rest }, { index, label, value }) => {
                if (label === createNewOption.label && index === 0) {
                    return (
                        <CreateNewDropDownItem
                            {...rest}
                            children={label}
                            key={index}
                            value={value}
                            onClick={() => {
                                history.push(URLPaths.CONTENT_CREATE_VOICE_CALL);
                            }}
                        />
                    );
                } else {
                    return <MenuItem {...rest} children={label} key={value.id} value={value} />;
                }
            }}
            type="string"
        />
    );
};

export default AutocompleteVoiceCallContent;
